/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { BaseThreadFragmentFragmentGQLType } from '../queries/GetThreadById.gql.generated';
import { gql } from '@apollo/client';
import { BaseThreadFragmentFragmentDocGQLType } from '../queries/GetThreadById.gql.generated';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CreateThreadWithCommentMutationVariablesGQLType = Types.Exact<{
  comment: Types.Scalars['String'];
  isPinned?: Types.Maybe<Types.Scalars['Boolean']>;
  participatingOrganizationIds: Array<Types.Scalars['UUID']> | Types.Scalars['UUID'];
  domain: Types.ThreadDomainGQLType;
  domainIdentifier: Types.Scalars['String'];
}>;


export type CreateThreadWithCommentMutationGQLType = (
  { __typename?: 'Mutation' }
  & { thread: (
    { __typename?: 'Thread' }
    & BaseThreadFragmentFragmentGQLType
  ) }
);


export const CreateThreadWithCommentDocumentGQLType = gql`
    mutation CreateThreadWithComment($comment: String!, $isPinned: Boolean, $participatingOrganizationIds: [UUID!]!, $domain: ThreadDomain!, $domainIdentifier: String!) {
  thread: createThread(
    comment: $comment
    isPinned: $isPinned
    participatingOrganizationIds: $participatingOrganizationIds
    domain: $domain
    domainIdentifier: $domainIdentifier
  ) {
    ...BaseThreadFragment
  }
}
    ${BaseThreadFragmentFragmentDocGQLType}`;
export type CreateThreadWithCommentMutationFnGQLType = Apollo.MutationFunction<CreateThreadWithCommentMutationGQLType, CreateThreadWithCommentMutationVariablesGQLType>;

/**
 * __useCreateThreadWithCommentMutation__
 *
 * To run a mutation, you first call `useCreateThreadWithCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThreadWithCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThreadWithCommentMutation, { data, loading, error }] = useCreateThreadWithCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *      isPinned: // value for 'isPinned'
 *      participatingOrganizationIds: // value for 'participatingOrganizationIds'
 *      domain: // value for 'domain'
 *      domainIdentifier: // value for 'domainIdentifier'
 *   },
 * });
 */
export function useCreateThreadWithCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateThreadWithCommentMutationGQLType, CreateThreadWithCommentMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThreadWithCommentMutationGQLType, CreateThreadWithCommentMutationVariablesGQLType>(CreateThreadWithCommentDocumentGQLType, options);
      }
export type CreateThreadWithCommentMutationHookResult = ReturnType<typeof useCreateThreadWithCommentMutation>;
export type CreateThreadWithCommentMutationResultGQLType = Apollo.MutationResult<CreateThreadWithCommentMutationGQLType>;
export type CreateThreadWithCommentMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateThreadWithCommentMutationGQLType, CreateThreadWithCommentMutationVariablesGQLType>;